export default "__VITE_ASSET__p7epHmCr__"